import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export const SelfcarePagination = ({ selfcareState, pageSearch, routerQuery }) => {
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	return (
		<nav className="flex-row my-3 justify-content-center" aria-label="Page navigation">
			{selfcareState.currentPage > 1 ? (
				<Link
					to={() => {
						searchParams.set("page", "1");
						return `/funecap/dossiers?${searchParams.toString()}`;
					}}
					className={"btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}>
					<i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i>
				</Link>
			) : (
				<button disabled className={"btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}>
					<i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i>
				</button>
			)}
			{selfcareState.currentPage > 1 ? (
				<Link
					to={() => {
						searchParams.set("page", selfcareState.currentPage - 1);
						return `/funecap/selfcare?${searchParams.toString()}`;
					}}
					className={"btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}>
					<i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i>
				</Link>
			) : (
				<button disabled className={"btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"}>
					<i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i>
				</button>
			)}

			<span className="btn rounded-sm bg-dim px-2 py-1 mx-1 d-flex justify-content-center align-items-center fs-aux">
				{selfcareState.currentPage} de {selfcareState.totalPages}
			</span>
			{selfcareState.currentPage < selfcareState.totalPages ? (
				<Link
					to={() => {
						searchParams.set("page", selfcareState.currentPage + 1);
						return `/funecap/selfcare?${searchParams.toString()}`;
					}}
					className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center">
					<i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i>
				</Link>
			) : (
				<button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center">
					<i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i>
				</button>
			)}
			{selfcareState.currentPage < selfcareState.totalPages ? (
				<Link
					to={() => {
						searchParams.set("page", selfcareState.totalPages);
						return `/funecap/selfcare?${searchParams.toString()}`;
					}}
					className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center">
					<i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i>
				</Link>
			) : (
				<button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center">
					<i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i>
				</button>
			)}
		</nav>
	);
};